export default {"src":"/_next/static/media/whatsapp-icon.8e666318.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};